import React, { LegacyRef, forwardRef } from 'react';
import { RoundButton } from '../RoundButton';
import { View } from 'react-native';

const reportIcon = require('assets/report.svg');

export const ReportButton = forwardRef(
  (props: { onPress: () => void }, ref: LegacyRef<View>) => {
    return (
      <View ref={ref}>
        <RoundButton
          onPress={props.onPress}
          testID={'ReportButton'}
          image={reportIcon}
          color={'#dd3416'}
        />
      </View>
    );
  },
);
